
<!-----------------fillering------------------->
<div class="card-body">
    <div class="row">
    <div class="col-md-6">
        <div class="form-group" data-select2-id="43">
            <label>Select Brand</label>
            
            <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible size" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true">
            <option selected="selected" data-select2-id="1">All</option>
            <option *ngFor="let d of brand" data-select2-id="2" [value]="d.brand_id">{{d.brand_name}}</option>
           
            <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
            </select>
            
            <span class="dropdown-wrapper" aria-hidden="true"></span>
        </div>
    </div>

    <div class="col-md-6">
    <div class="form-group">
   
        <div class="form-group">
            <label>Search Product</label>
            <div class="input-group">
                <input type="search" class="form-control form-control-lg" placeholder="Search Product" id="search" name="search" [(ngModel)]="search" (ngModelChange)="Search();">
                <div class="input-group-append">
                <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
                <i class="fa fa-search"></i>
                </button>
                </div>
                </div>
            
        </div>
    </div>
   
    </div>
  
    </div>





<!-------------searching----------------
<div class="input-group">
    <input type="search" class="form-control form-control-lg" placeholder="Search Product" id="search" name="search" [(ngModel)]="search">
    <div class="input-group-append">
    <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
    <i class="fa fa-search"></i>
    </button>
    </div>
    </div>
---------------for select brand-----------
<div class="form-group" data-select2-id="43">
    <label>Select Brands</label>
    
    <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true">
    <option selected="selected" data-select2-id="1">All</option>
    <option *ngFor="let d of brand" data-select2-id="2" [value]="d.brand_id">{{d.brand_name}}</option>
   
    <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
    </select>
    
    <span class="dropdown-wrapper" aria-hidden="true"></span>
</div>--->
<!---------------------------------new ui---------------------------------------------------->
<!----------
<div  style="min-height: 500.44px;">

    <section class="content-header ">
    <div class="container-fluid ">
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Products</h1>
    </div>
   
    </div>
    </div>
    </section>
------------------->
<section class="content-header ">
    <div class="row mb-2 ">
   <div class="col-sm-6">     
   <h1>Products</h1>

   </div>
   </div>
   </section>

    <section class="content">
    
    <div class="card">
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 40%">
    Name
    </th>

    <th style="width: 20%">
    Product SUK
    </th>

    <th style="width: 20%">
    Product Code
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
        {{c.product_name}}
    </a>
    </td>
    
    <td>
        {{c.product_sku}}
    </td>

    
    <td>
        {{c.product_code}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)='productDetails();getValue(c.product_id);'>
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='getValue(c.product_id);EditProducts();'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    <!--
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    -->
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------------------paging------------------------------------->
<div class="col-sm-12 col-md-7">
    <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
        <ul class="pagination">
            <li class="paginate_button page-item previous" id="example2_previous">
            <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>

            <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
           
            <li class="paginate_button page-item next" id="example2_next">
            <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
        </ul>
    </div></div></div>











<!--
<table class="table table-hover text-nowrap" >
    <thead>
    <tr>
    <th>Name</th>
    <th>Product SKU</th>
    </tr>
    </thead>
    <tbody  *ngFor="let c of output">
    <tr  (click)='productDetails();getValue(c.product_id)'>
    <td>{{c.product_name}}</td>
    <td>{{c.product_sku}}</td>
    </tr>
    </tbody>
    </table>






<ul *ngFor="let c of output">
    <li (click)='productDetails();getValue(c.product_id)'>{{c.product_name}}</li>
    <li class="nobull">{{c.product_sku}}</li>
</ul>

-->